import React, { useEffect, useRef } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';

import Filter from '@helpers/Filter';

import CommonBtn from '@views/components/CommonBtn';

import * as Cache from '../../../../../app/helpers/Cache';
import { IDeviceBindApplyInfo, IDeviceBindInfo } from '@apis/types';
import successImg from './images/success.png';
import rejectImg from './images/rejected.png';
import applyingImg from './images/applying.png';
import {pushAndPopUntil} from '@helpers/BrowserHistory';
import Toast from '@widgets/Toast';
import FridayService from '@services/friday';

// 0：审批中; 1：审批通过; 2：审批驳回
export const ResultType = {
  APPLYING: 0,
  SUCCESS: 1,
  REJECT: 2,
}

const DeviceBindResult = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const deviceBindInfo = useRef<IDeviceBindInfo>(Cache.get('deviceBindInfo'));
  const lastApplyInfo = useRef<IDeviceBindApplyInfo>(Cache.get('lastApplyInfo'));

  const getAdminText = (): string => {
    const phone = deviceBindInfo.current.phone || '';
    const ownerName = deviceBindInfo.current.ownerName || '';
    if (phone.length <= 0) {
      return ownerName.slice(0, 1) + '*'.repeat(ownerName.length - 1);
    } else {
      return ownerName.slice(0, 1) + '*'.repeat(ownerName.length - 1) + ' ' + phone.slice(0, 3) + '*'.repeat(4) + phone.slice(7);
    }
  }

  const renderContent = () => {
    let iconImage, titleText, subText;
    switch(parseInt(params.current.type)) {
      case ResultType.APPLYING:
        iconImage = applyingImg;
        titleText = '申请审批中';
        subText = `已向管理员（${getAdminText()}）发送绑定申请通过后即可绑定`;
        break;
      case ResultType.REJECT:
        iconImage = rejectImg;
        titleText = '申请绑定失败';
        subText = `您的申请绑定欧阳娜娜的学生证已被管理员（${getAdminText()}）驳回`;
        break;
      default: {
        iconImage = successImg;
        titleText = '申请发送成功';
        subText = '申请通过后即可绑定该设备';
        break;
      }
    }

    return (
      <div className='flex' styleName='content'>
        <img styleName='icon' src={iconImage} alt=''/>
        <p styleName='title'>{titleText}</p>
        <p>{subText}</p>
      </div>
    )
  }

  const onApplyAgain = () => {
    FridayService.addEvent('application_binding_application_for_binding_failed_apply_again_click');
    if (!lastApplyInfo.current.applyTime || (Date.now() - lastApplyInfo.current.applyTime) > 3 * 24 * 3600 * 1000) {
      pushAndPopUntil(`${PUBLIC_URL}/devicebindapply`, ['/devicebindapply', '/']);
    } else {
      Toast.show({
        type: 'strip',
        title: '3天内不可再次申请'
      });
    }
  }

  useEffect(() => {
    switch(parseInt(params.current.type)) {
      case ResultType.APPLYING:
        FridayService.addEvent('application_binding_application_approval_show');
        break;
      case ResultType.REJECT:
        FridayService.addEvent('application_binding_application_binding_failed_show');
    }
  }, []);

  return (
    <div styleName="container">
      <NavBar
        title="申请绑定"
      />
      {renderContent()}
      {parseInt(params.current.type) === ResultType.REJECT ? (
      <CommonBtn
        style={{position: 'absolute', bottom: '.32rem', left: 0, right: 0}}
        onConfirm={onApplyAgain}
        btnText="再次申请"/>) : null}
    </div>
  )
}

export default DeviceBindResult;
